export default __webpack_public_path__ + "static/media/bhojpuri_bf_1.f18d11a8.mp3";